import { PhotoEvent } from '../../../../photo/photo/domain/event/photo.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class PhotosUnlinkedFromAssetEvent extends PhotoEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: PhotosUnlinkedFromAssetEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
PhotosUnlinkedFromAssetEvent.type = 'com.treeplotter.api.photo.photosUnlinkedFromAsset.v1';
EventRegistry.register(PhotosUnlinkedFromAssetEvent.type, PhotosUnlinkedFromAssetEvent);
//# sourceMappingURL=photos-unlinked-from-asset.event.js.map